import { AfterViewInit, Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { KENDO_PDFVIEWER } from '@progress/kendo-angular-pdfviewer';

import { CommonModule } from '@angular/common';
import { FileServices } from '../@theme/services/file.service';
import { data } from './base64data';
import { rotatePdfBase64 } from '../pages/Pdfviewer/pdf-rotate';

@Component({
  selector: 'gd-pdfviewer',
  standalone: true,
  imports: [CommonModule, KENDO_PDFVIEWER],
  template: `
<div class="shadow-lg rounded-lg p-4 overflow-hidden">
  <div class="flex justify-end gap-2 pb-2">
    <button type="button" title="Rotate left" (click)="rotate(-90)" [disabled]="!base64 || rotating"
      class="px-3 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 text-black dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50">
      <i class="fa fa-rotate-left"></i> Rotate left
    </button>
    <button type="button" title="Rotate right" (click)="rotate(90)" [disabled]="!base64 || rotating"
      class="px-3 py-1 text-sm rounded-md border border-gray-300 dark:border-gray-600 text-black dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50">
      <i class="fa fa-rotate-right"></i> Rotate right
    </button>
  </div>
  <kendo-pdfviewer
    class="w-full max-w-full"
    style="height: 740px; max-width: 100%; overflow-x: hidden;"
    [data]="base64"
  >
  </kendo-pdfviewer>
</div>

  `,
  styles: []
})
export class PDFViewerComponent implements OnChanges, AfterViewInit, OnDestroy {
  /** Input PDF as Blob to render */
  @Input() rawPdfData?: Blob;
  @Input() FilePath?: string | string[];
  @Input() outputClientId?: string;
  @Input() outputrepId?: string;
  @Input() outquery?: string;
  @Input() blotterId?: string;
  @Input() driverlicenseview?: string;
  @Input() outputfiletrans?: string;
  @Input() outputdriverview?: string;
 @Input() base64: string = '';
  /** Base64 string passed to kendo-pdfviewer */

  public rotating = false;

  /** Rotates all pages and reloads them into the viewer (Kendo has no rotate tool). */
  async rotate(delta: 90 | -90): Promise<void> {
    if (!this.base64 || this.rotating) return;
    this.rotating = true;
    try {
      this.base64 = await rotatePdfBase64(this.base64, delta);
    } catch (err) {
      console.error('PDF rotate failed', err);
    } finally {
      this.rotating = false;
    }
  }


  constructor(private file: FileServices) {
    // Initialize with default data if no rawPdfData provided
    const initialBlob = this.base64ToBlob(data, 'application/pdf');
    this.convertBlobToBase64(initialBlob);
  }

  ngOnChanges(): void {
    this.onInitOrChange();
  }

  ngAfterViewInit(): void {
    this.onInitOrChange();
  }

  /** Converts incoming Blob or default data into base64 string */
  onInitOrChange(): void {
    if (this.rawPdfData) {
      this.convertBlobToBase64(this.rawPdfData);
    }
  }

  /** Utility: convert base64 string to Blob */
  private base64ToBlob(base64: string, mime = 'application/pdf'): Blob {
    const byteChars = atob(base64);
    const byteNumbers = Array.from(byteChars).map(c => c.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mime });
  }

  /** Utility: convert Blob to base64 for PDFViewer */
  private convertBlobToBase64(blob: Blob): void {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = (e) => {
      const result = e.target?.result as string;
      this.base64 = result.split(',')[1];
 //     console.log('PDF base64 updated. length:', this.base64.length);
    };
  }

  ngOnDestroy(): void {
    // No manual cleanup needed for Kendo PDFViewer
    this.base64 = '';
  }
}
